var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._t("header")],2),_c('v-expansion-panel-content',[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }